<template>
  <TabGroup>
    <div class="grid grid-cols-12 md:grid-cols-[auto,1fr] md:gap-4">
      <div class="md:col-auto col-span-12">
        <TabList>
          <Tab
              v-slot="{ selected }"
              as="template"
              v-for="(item, i) in [{
                    title: $t('menuItems.boost'),
                  },
                  /*{
                    title: $t('message.account'),
                  },
                  {
                    title: $t('message.currency buy'),
                  },*/
                  {
                    title: $t('message.currency sell'),
                  }]"
              :key="i"
          >
            <button
                :class="[
                selected
                  ? 'text-white bg-primary-500'
                  : 'text-slate-500 bg-white dark:bg-slate-700 dark:text-slate-300',
              ]"
                class="text-sm font-medium md:block inline-block mb-4 last:mb-0 capitalize ring-0 foucs:ring-0 focus:outline-none px-4 rounded-md py-2 transition duration-150 md:w-full"
            >
              {{ item.title }}
            </button>
          </Tab>
        </TabList>
      </div>
      <div class="md:col-auto col-span-12">
        <TabPanels>
          <TabPanel>
            <Boost/>
          </TabPanel>
<!--          <TabPanel>
            <Account/>
          </TabPanel>
          <TabPanel>
            <currency-buy/>
          </TabPanel>-->
          <TabPanel>
            <currency-sell/>
          </TabPanel>
        </TabPanels>
      </div>
    </div>
  </TabGroup>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {TabGroup, TabList, Tab, TabPanels, TabPanel} from "@headlessui/vue";
import Boost from "@/views/manageApplicants/currencySell/applicantDetails/tabs/tookOrders/boost.vue"
import Account from "@/views/manageApplicants/currencySell/applicantDetails/tabs/tookOrders/account.vue";
import CurrencyBuy from "@/views/manageApplicants/currencySell/applicantDetails/tabs/tookOrders/currencyBuy.vue"
import CurrencySell from "@/views/manageApplicants/currencySell/applicantDetails/tabs/tookOrders/currencySell.vue";

const {t, locale} = useI18n({useScope: 'global'})
</script>
